'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var coreRenderer = require('@tempi/core-renderer');

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const MOBILE_WIDTH = 767;
const DEFAULT_WEBSITE_HEADER_DESKTOP = {
  stickyTop: true,
  menuConfig: {
    commonStyle: {
      columnGap: 32
    },
    align: coreRenderer.Alignment.right
  },
  logoConfig: {
    show: true,
    src: "https://lh3.googleusercontent.com/bhg6FoxZPA5S6q50_Gmu6YgMt2GcKxpjsbnaRvvHUwSV9JSnAj83TpbJEHIJjgKnbNoZmM7Mnx0pBlUau5CG2yIOG5v7rGc",
    align: coreRenderer.Alignment.left,
    commonStyle: {
      width: 100
    },
    spacingWithMenu: 32
  },
  menuItemConfig: {
    commonStyle: {
      color: "#000000",
      hover: {
        color: "#008cff"
      }
    }
  },
  commonStyle: {
    backgroundColor: "#ffffff",
    padding: {
      top: 30,
      right: 16,
      bottom: 30,
      left: 16
    }
  }
};
const DEFAULT_WEBSITE_HEADER_MOBILE = {
  commonStyle: {
    padding: {
      top: 24,
      right: 16,
      bottom: 24,
      left: 16
    }
  }
};
const DEFAULT_WEBSITE_HEADER = {
  desktop: __spreadValues({}, DEFAULT_WEBSITE_HEADER_DESKTOP),
  mobile: __spreadValues({}, DEFAULT_WEBSITE_HEADER_MOBILE)
};
const DEFAULT_BUTTONS = [
  {
    text: "",
    buttonStyle: {
      backgroundColor: "#7367F0",
      color: "#ffffff",
      height: 40,
      width: 100,
      borderRadius: 16,
      borderStyle: "solid",
      borderWidth: 0
    }
  }
];

exports.DEFAULT_BUTTONS = DEFAULT_BUTTONS;
exports.DEFAULT_WEBSITE_HEADER = DEFAULT_WEBSITE_HEADER;
exports.DEFAULT_WEBSITE_HEADER_DESKTOP = DEFAULT_WEBSITE_HEADER_DESKTOP;
exports.DEFAULT_WEBSITE_HEADER_MOBILE = DEFAULT_WEBSITE_HEADER_MOBILE;
exports.MOBILE_WIDTH = MOBILE_WIDTH;
